import i18n from '@/i18n'
import { configurationService } from '@/helpers/services/configuration.service'
import { filtersHelper } from '@/utils'
import {
  LISTING_STATE,
  listingMutations,
  listAction,
  detailAction,
  writeAction,
} from '@/state/listing.store'

export const CONFIGURATION_MODULE = 'configuration'

export const GET_ALL_CONFIGURATION = 'getAllConfiguration'
export const GET_CONFIGURATION = 'getConfiguration'
export const UPDATE_CONFIGURATION = 'updateConfiguration'

export const state = LISTING_STATE()

/**
 * The key is the id — routes are `/configurations/{key}`, not `/{id}`.
 *
 * `value` stays exactly as stored. The screen needs the raw text to put in the
 * input and `valueType` to decide which input; typing it here would mean the
 * form round-trips a different shape than it received.
 */
function mapConfigurationRow(item) {
  return {
    id: item.key,
    key: item.key,
    // Shown as words rather than snake_case: `max_login_attempt` reads as
    // "Max login attempt" in the table and the raw key is still the id.
    label: humanise(item.key),
    value: item.value,
    valueType: item.value_type,
    isViewable: item.is_viewable,
    updatedBy: item.updated_by,
    updatedAt: filtersHelper.getDateFormat(item.updated_at),
  }
}

export const actions = {
  [GET_ALL_CONFIGURATION]: listAction((filter) => configurationService.getAllConfigurations(filter)),

  [GET_CONFIGURATION]: detailAction(({ key }) => configurationService.getConfiguration(key)),

  [UPDATE_CONFIGURATION]: writeAction(
    ({ key, value }) => configurationService.updateConfiguration(key, value),
    () => i18n.t('label.updateX', [i18n.t('module.configuration')]),
    GET_ALL_CONFIGURATION
  ),
}

export const mutations = listingMutations(mapConfigurationRow)

function humanise(key) {
  if (!key) return ''

  const words = String(key).replace(/\./g, ' · ').split('_').join(' ')

  return words.charAt(0).toUpperCase() + words.slice(1)
}
